import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    apiURL: 'https://api.vividartsapp.com',
    errors: 0,
    axiosConfig: {
      headers: {
        'enterprise-id': window.VividArts.eId,
        'edomain': window.VividArts.domain || window.location.hostname.split('.')[0]
      }
    },
    placeholderArtistImg: 'http://res.cloudinary.com/vividarts/image/upload/c_scale,w_600/v1518396723/directory/ccpbc-artist-placeholder.jpg',

    artworksRef: {},
    artistsRef: {},
    blogsRef: {},
    blogSourcesRef: {},
    usersRef: {},
    authorsRef: {},
    eventsRef: {},
    placesRef: {},
    regionsRef: {},
    enterprisesRef: {},

    artworks: [],
    artists: [],
    blogs: [],
    blogSources: [],
    users: [],
    authors: [],
    events: [],
    places: [],
    regions: [],
    enterprises: [],

    states: [ 'AK', 'AL', 'AR', 'AS', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'GU', 'HI', 'IA', 'ID', 'IL', 'IN',
      'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY',
      'OH', 'OK', 'OR', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'VI', 'VT', 'WA', 'WI', 'WV', 'WY'],
    countries: ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua &amp; Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas',
      'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia &amp; Herzegovina', 'Botswana', 'Brazil', 'British Virgin Islands',
      'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Chad', 'Chile', 'China', 'Colombia', 'Congo', 'Cook Islands', 'Costa Rica',
      'Cote D Ivoire', 'Croatia', 'Cruise Ship', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea',
      'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Polynesia', 'French West Indies', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana',
      'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India',
      'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kuwait', 'Kyrgyz Republic', 'Laos', 'Latvia',
      'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Mauritania',
      'Mauritius', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia',
      'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal',
      'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russia', 'Rwanda', 'Saint Pierre &amp; Miquelon', 'Samoa', 'San Marino', 'Satellite', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles',
      'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'South Africa', 'South Korea', 'Spain', 'Sri Lanka', 'St Kitts &amp; Nevis', 'St Lucia', 'St Vincent', 'St. Lucia', 'Sudan',
      'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor L\'Este', 'Togo', 'Tonga', 'Trinidad &amp; Tobago', 'Tunisia',
      'Turkey', 'Turkmenistan', 'Turks &amp; Caicos', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands', 'Uruguay', 'Uzbekistan', 'Venezuela', 'Vietnam', 'Virgin Islands (US)',
      'Yemen', 'Zambia', 'Zimbabwe'
    ],
    statuses: ['active', 'pending', 'deleted'],
    types: ['Mural', 'Sculpture', 'Installation', 'Live Performance', 'Exhibition', 'Film Viewings', 'Art Walks', 'Social Event', 'Opening Reception', 'Artist Only'],
    artworkTour: {
      artworks: [],
      directions: {}
    }
  },
  mutations: {
    setArtworks (state, payload) {
      console.log('Artworks ->', payload)
      state.artworks = payload.artworks
      state.artworksRef = payload.artworksRef
    },
    setArtists (state, payload) {
      console.log('Artists ->', payload)
      state.artists = payload.artists
      state.artistsRef = payload.artistsRef
    },
    setBlogs (state, payload) {
      console.log('Blogs ->', payload)
      state.blogs = payload.blogs
      state.blogsRef = payload.blogsRef
    },
    setBlogSources (state, payload) {
      console.log('BlogSources ->', payload)
      state.blogSources = payload.blogSources
      state.blogSourcesRef = payload.blogSourcesRef
    },
    setUsers (state, payload) {
      console.log('Authors ->', payload)
      state.users = payload.users
      state.usersRef = payload.usersRef
    },
    setAuthors (state, payload) {
      console.log('Authors ->', payload)
      state.authors = payload.authors
      state.authorsRef = payload.authorsRef
    },
    setEvents (state, payload) {
      console.log('Events ->', payload)
      state.events = payload.events
      state.eventsRef = payload.eventsRef
    },
    setPlaces (state, payload) {
      console.log('Places ->', payload)
      state.places = payload.places
      state.placesRef = payload.placesRef
    },
    setRegions (state, payload) {
      console.log('Regions ->', payload)
      state.regions = payload.regions
      state.regionsRef = payload.regionsRef
    },
    setEnterprises (state, payload) {
      console.log('Enterprises ->', payload)
      state.enterprises = payload.enterprises
      state.enterprisesRef = payload.enterprisesRef
    },
    setArtworkTour (state, payload) {
      console.log('Artwork Tour ->', payload)
      if (payload.artworks) { state.artworkTour.artworks = payload.artworks }
      if (payload.directions) { state.artworkTour.directions = payload.directions }
    }
  },
  actions: {
    buildArtworkTour ({ commit, state }, data) {
      console.log('directions data', data)
      var url = 'http://vividartsapp.com/embeded/tours.php'

      var params = new URLSearchParams()
      params.append('u', data)

      axios.post(url, params)
      .then(response => {
        // JSON responses are automatically parsed.
        console.log('buildArtworkTour', response.data)

        if (response.data.status === 'OK') {
          commit('setArtworkTour', { directions: response.data })
        //   this.loadingRoute = false
        //
        //   this.tourArtworkOrder = response.data.routes[0].waypoint_order
        //
        //   var orderedSelectedArtworks = []
        //   for (var i = 0; i < this.tourArtworkOrder.length; i++) {
        //     var idx = this.tourArtworkOrder[i]
        //     orderedSelectedArtworks.push(this.selectedArtworks[idx])
        //   }
        //   this.selectedArtworks = orderedSelectedArtworks
        //   this.tourMapPaths = this.decode(response.data.routes[0].overview_polyline.points)
        //     .map(function (item) {
        //       return {
        //         lat: item.latitude,
        //         lng: item.longitude
        //       }
        //     })
        //   this.directionsList = response.data.routes[0].legs[0].steps.map(function (item) {
        //     return {
        //       avatar: '',
        //       subtitle: item.html_instructions,
        //       title: item.travel_mode,
        //       polyline: item.polyline
        //     }
        //   })
        }
      })
      .catch(e => {
        console.log(e)
        // this.errors.push(e)
        // this.loadingRoute = true

        // this.loadingRoute = false
        // this.appStep = 1
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js